export const SET_INVOICES = 'SET_INVOICES';
export const SET_INVOICE = 'SET_INVOICE';
export const SET_INVOICE_ID = 'SET_INVOICE_ID';
export const SET_COUPON_CODE = 'SET_COUPON_CODE';
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
export const RESET_PAYMENT_INFO = 'RESET_PAYMENT_INFO';


// WEBPACK FOOTER //
// ./src/store/modules/invoices/mutations.js